import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import {Chart, Title} from 'chart.js';
Chart.register(Title);
function PieChart({ chartData }) {
  return <Pie data={chartData} />;
}

export default PieChart;